import { memo, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, PlusIcon } from '@quickmd-llc/design-system'
import { NEW_INTAKE_FORM_ROUTE } from '@/utils/constants'

/*
 * SCSS → Tailwind mapping (IntakeFormsTableTitle.scss deleted):
 *   .if-header-bar:
 *     display:flex / align-items:center / justify-content:space-between → flex items-center justify-between
 *     padding: 24px 28px    → py-sp-3 px-[28px]  (sp-3=24px; 28px — no exact DS token)
 *     background: #ffffff   → bg-white
 *     border: 1px solid --border-card, 1px 1px 0 1px → border border-b-0 border-shade-10
 *     border-radius: 8px 8px 0 0 → rounded-t-large
 *   .if-header-left:
 *     display:flex / flex-direction:column / gap:4px → flex flex-col gap-sp-0.5
 *   .if-title:
 *     font-size:20px / font-weight:600 / line-height:28px → text-size-5 font-semibold leading-7
 *     color: --text-dark → text-text-dark
 *   .if-subtitle:
 *     font-size:16px / font-weight:400 / line-height:20px → text-size-4 font-normal leading-5
 *     letter-spacing:0.12px → tracking-[0.12px]  (no exact DS token)
 *     color: --text-medium → text-text-light  (DS text.light = #253845B2 ≈ rgba(37,56,69,0.7))
 */
const IntakeFormsTableTitle = memo(() => {
  const navigate = useNavigate()
  const location = useLocation()

  const onPressNewBtn = useCallback(() => {
    navigate(`${NEW_INTAKE_FORM_ROUTE}${location.search || ''}`)
  }, [navigate, location.search])

  return (
    <div
      className='flex items-center justify-between rounded-t-large border border-b-0 border-shade-10 bg-white px-[28px] py-sp-3'
      data-testid='pw_if-list-title'>
      <div className='flex flex-col gap-sp-0.5'>
        <span className='text-size-5 font-semibold leading-7 text-text-dark'>Build intake forms</span>
        <span className='text-size-4 font-normal leading-5 tracking-[0.12px] text-text-light'>
          Patients complete these forms as part of their intake for each service.
        </span>
      </div>
      <Button priority='secondary' size='m' onClick={onPressNewBtn} data-testid='pw_if-new-btn'>
        <PlusIcon iconSize='m' />
        New intake form
      </Button>
    </div>
  )
})

IntakeFormsTableTitle.displayName = 'IntakeFormsTableTitle'

export { IntakeFormsTableTitle }
